angular.module('unergie.main')
.factory('PrmValuesValidatorService', (ApiUser) => {
    const CONTRACT_FIELDS = [
        'id',
        'id_category',
        'prm_category',
        'chosen_phase',
        'routing_tariff',
        'choosen_routing_tariff',
        'id_p_calendar',
        'choosen_id_p_calendar',
        'max_power',
        'choosen_max_power',
        'choosen_temp_class_powers',
        'choosen_auto_prod_coupling',
        'choosen_auto_prod_devices_amount',
        'choosen_auto_prod_power',
        'choosen_long_usage_context',
        'choosen_long_usage_package',
        'choosen_sscpt',
        'provider_offer',
        'id_ref_promo',
        'subscription_type',
    ]

    const PRM_FIELDS = [
        'nb_wires',
        'metter_kind',
        'routing_tariff',
        'id_p_calendar',
        'max_power',
        'temp_class_powers',
        'auto_prod_coupling',
        'auto_prod_devices_amount',
        'auto_prod_power',
        'long_usage_context',
        'long_usage_package',
        'service_level',
        'communicating',
        'last_routing_tariff_modif_date',
        'distributor_status',
        'powered_status',
        'segment',
    ]

    function validate(payload, pro, amendment = false) {
        const strippedPayload = _.assign({}, _.pick(payload, CONTRACT_FIELDS), { prm: _.pick(payload.prm, PRM_FIELDS) })
        return ApiUser.validatedModificationValues({ pro, amendment }, strippedPayload).$promise
    }

    return {
        validate,
    }
})
